var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".youtube-logo .a{fill:#cdcdce;}")),React.createElement("path",{"className":"a","d":"M31.663,4.85a6.917,6.917,0,0,0-1.274-3.175A4.549,4.549,0,0,0,27.177.325C22.716,0,16.006,0,16.006,0h-.013S9.284,0,4.8.325a4.587,4.587,0,0,0-3.211,1.35A7,7,0,0,0,.325,4.85,47.99,47.99,0,0,0,0,10.038v2.425a47.609,47.609,0,0,0,.325,5.175A6.917,6.917,0,0,0,1.6,20.813a5.346,5.346,0,0,0,3.524,1.362c2.562.25,10.871.325,10.871.325s6.722-.013,11.2-.338a4.586,4.586,0,0,0,3.211-1.35,6.917,6.917,0,0,0,1.274-3.175A47.608,47.608,0,0,0,32,12.462V10.038a49.939,49.939,0,0,0-.337-5.188ZM12.695,15.4V6.412l8.647,4.512L12.695,15.4Z","key":1})]);
}

Youtube.defaultProps = {"width":"32","height":"22.5","viewBox":"0 0 32 22.5","className":"youtube-logo"};

module.exports = Youtube;

Youtube.default = Youtube;
